import styled from "styled-components";
import {BaseButton, buttonStyles} from "components/Buttons";

export const PrimaryButton = styled(BaseButton)`
	${({theme}) => buttonStyles(theme.button.primary)}
`;
